import { AlertTriangle, Trash2, X } from 'lucide-react';
import { useDeletePropertyAttribute } from '../hooks/useDeletePropertyAttribute';

const DeletePropertyAttributeModal = ({ isOpen, setIsOpen, attribute }) => {
  const { mutate: deleteAttribute, isPending } = useDeletePropertyAttribute();

  const handleDelete = () => {
    if (attribute?._id) {
      deleteAttribute(attribute._id, {
        onSuccess: () => setIsOpen(false),
      });
    }
  };

  if (!isOpen) return null;

  return (
    <div className='fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4'>
      <div className='bg-card border border-border rounded-lg w-full max-w-md'>
        <div className='flex items-center justify-between px-6 py-4 border-b border-border'>
          <div className='flex items-center space-x-2'>
            <div className='p-2 bg-destructive/10 rounded-lg'>
              <AlertTriangle className='text-destructive' size={20} />
            </div>
            <h2 className='text-lg font-semibold'>Delete Attribute</h2>
          </div>
          <button onClick={() => setIsOpen(false)} className='p-1 hover:bg-muted rounded-md transition-colors'>
            <X size={20} />
          </button>
        </div>

        <div className='px-6 py-4 space-y-4'>
          <p className='text-sm text-muted-foreground'>
            Are you sure you want to delete <span className='font-semibold text-foreground'>"{attribute?.label}"</span>?
          </p>

          <div className='bg-destructive/10 border border-destructive/20 rounded-lg p-3'>
            <p className='text-xs text-destructive'>
              Properties that already have this option selected will keep showing it by its raw key until re-edited —
              it just won't be offered as a choice for new selections.
            </p>
          </div>
        </div>

        <div className='flex justify-end space-x-3 px-6 py-4 border-t border-border'>
          <button
            onClick={() => setIsOpen(false)}
            disabled={isPending}
            className='px-4 py-2 text-sm border border-border rounded-md hover:bg-accent transition-colors disabled:opacity-50'
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={isPending}
            className='px-4 py-2 text-sm bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors disabled:opacity-50'
          >
            {isPending ? (
              <div className='flex items-center justify-center'>
                <div className='animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2' />
                Deleting...
              </div>
            ) : (
              <div className='flex items-center justify-center'>
                <Trash2 size={16} className='mr-2' />
                Delete
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeletePropertyAttributeModal;
